// Given following code snippet, what will be the console output?
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
export default function Question() {
    const [state, setState] = useState(0)
  
    console.log(state)
  
    useEffect(() => {
      setState(state => state + 1)
    }, [])
  
    useEffect(() => {
      console.log(state)
      setTimeout(() => {
        console.log(state)
      }, 100)
    }, [])
  
    return null;
}